import { render, staticRenderFns } from "./CustomerMetrics.vue?vue&type=template&id=00604260&scoped=true"
import script from "./CustomerMetrics.vue?vue&type=script&lang=js"
export * from "./CustomerMetrics.vue?vue&type=script&lang=js"
import style0 from "./CustomerMetrics.vue?vue&type=style&index=0&id=00604260&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00604260",
  null
  
)

export default component.exports